import auth from "./auth";
import estimator from "./estimator";
import loginKC from "./loginKC";

const api = {
  auth,
  estimator,
  loginKC
};

export default api;
